export const MODEL_STEPS = [
	{ label: 'Misión del Puesto' },
	{ label: 'Actividades del Puesto' },
	{ label: 'Conocimientos Requeridos' },
	{ label: 'Instrucción Formal' },
	{ label: 'Destrezas Requeridas' },
	{ label: 'Compentencias Requeridas' },
	{ label: 'Indicadores de Resultados' },
];

export const JOBS_TYPES = [
	{
		label: 'Activos',
		key: 1,
	},
	{
		label: 'Inactivos',
		key: 0,
	},
	{
		label: 'Todos',
		key: null,
	},
];

export default {};




// WEBPACK FOOTER //
// ./src/modules/job-profile/constants/constants.js